import { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  Box,
  Button,
  FormControl,
  Input,
  ModalBody,
  ModalHeader,
} from '@chakra-ui/react';
import { useAsyncCallback } from 'react-async-hook';
import { useForm } from 'react-hook-form';
import { Label } from 'components/elements/Label';
import { Text } from 'components/elements/Text';
import { CrossIcon } from 'components/icons/CrossIcon';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { useUpdateCollection } from 'hooks/useCollections';
import { CollectionProjectList } from 'types';

type AddCollectionNameProps = {
  isOpen: boolean;
  onClose(): void;
  filteredCollection: CollectionProjectList | undefined;
};

type NameForm = {
  collectionName: string;
};

export const UpdateCollectionName = ({
  isOpen,
  onClose,
  filteredCollection,
}: AddCollectionNameProps) => {
  const { register, handleSubmit, reset } = useForm<NameForm>({
    defaultValues: {
      collectionName: '',
    },
  });
  const { execute, loading } = useAsyncCallback(useUpdateCollection);

  useEffect(() => {
    if (isOpen && filteredCollection) {
      reset({
        collectionName: filteredCollection.name || '',
      });
    }
  }, [isOpen, filteredCollection, reset]);

  const handleNameSave = ({ collectionName }: NameForm) => {
    if (filteredCollection) {
      execute(filteredCollection?.id, collectionName);
      reset();
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={{ pb: '17px' }}>
        <FlexColumn
          sx={{ height: '100%' }}
          justifyContent="flex-start"
          alignItems="center"
        >
          <ModalHeader sx={{ width: '100%', margin: '0px', padding: '17px 16px 0px' }}>
            <FlexRow alignItems="center" justifyContent="space-between">
              <Text size="lg" sx={{ fontSize: '20px' }} fontWeight={700}>
                Rename List
              </Text>
              <Box sx={{ cursor: 'pointer' }} onClick={onClose}>
                <CrossIcon stroke="#2C402E" opacity={0.2} />
              </Box>
            </FlexRow>
          </ModalHeader>
          <ModalBody sx={{ width: '100%', padding: '24px 16px' }}>
            <form onSubmit={handleSubmit(handleNameSave)}>
              <FormControl sx={{ width: '100%', marginBottom: '24px' }}>
                <Label
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    ml: '6px',
                  }}
                >
                  Name
                </Label>
                <Input
                  className="groupName"
                  variant="outlined"
                  disabled={loading}
                  sx={{
                    bgColor: 'transparent',
                    marginTop: '4px',
                    height: '50px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderColor: 'brand.dark-green-200',
                  }}
                  {...register('collectionName')}
                />
              </FormControl>
              <Box
                sx={{
                  display: 'flex',
                }}
              >
                <Button
                  color="secondary"
                  onClick={onClose}
                  sx={{
                    color: 'brand.army-green',
                    mr: '0.8rem',
                    padding: '16px',
                    height: '100%',
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  sx={{
                    backgroundColor: 'brand.army-green',
                    color: 'brand.white',
                    padding: '16px',
                    height: '100%',
                  }}
                >
                  Save & continue
                </Button>
              </Box>
            </form>
          </ModalBody>
        </FlexColumn>
      </ModalContent>
    </Modal>
  );
};
